export const CHANGE_FIXED_MISC_AMOUNT_COUNT = 'CHANGE_FIXED_MISC_AMOUNT_COUNT';

export const changeFixedMiscAmountCount = (payload) => ({
    type: CHANGE_FIXED_MISC_AMOUNT_COUNT,
    payload,
});
